module.exports = __webpack_public_path__ + "img/emoji_mangran.2f573527.png";